module.exports = __webpack_public_path__ + "static/img/Pfiffner.022a1e6b.jpg";